import { useEffect, useState } from "react";
import { subscribe, getQueue } from "@/lib/offline";

export function useOnlineStatus() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return online;
}

export function useQueueCount() {
  const [count, setCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const apply = (q) => {
      if (cancelled) return;
      setCount(q.filter((i) => i.status !== "failed_permanent").length);
      setFailedCount(q.filter((i) => i.status === "failed_permanent").length);
    };
    getQueue().then(apply);
    const off = subscribe(({ queue }) => apply(queue));
    return () => { cancelled = true; off(); };
  }, []);
  return { pending: count, failed: failedCount, total: count + failedCount };
}
